import { render, staticRenderFns } from "./Injection.vue?vue&type=template&id=0ad5c052&scoped=true"
import script from "./Injection.vue?vue&type=script&lang=js"
export * from "./Injection.vue?vue&type=script&lang=js"
import style0 from "./Injection.vue?vue&type=style&index=0&id=0ad5c052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5c052",
  null
  
)

export default component.exports